import { DropDown } from "@etframework/ui.components";
import { useStages } from "../../data/queries/stageQueries";
import useRolePermissionStore from "../../store/rolePermissionStore";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { getTextColor } from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import Enums from "../../types/enums";

export const StageDropdown = forwardRef(
  ({ id, initialValue, change, boardId, disabled }, ref) => {
    const { i18n } = useTranslation(["Overlay", "Shared"], {
      useSuspense: false,
    });

    const componentRef = useRef();
    const [currentBoardId, setCurrentBoardId] = useState(boardId);
    const { data, isPending } = useStages(currentBoardId);
    const rolePermissions = useRolePermissionStore(
      (state) => state.rolePermissions
    );

    const [backgroundColor, setBackgroundColor] = useState(
      initialValue?.Color ?? data?.[0]?.Color ?? ""
    );

    let stages = data;
    if (!rolePermissions?.CanComplete)
      stages = data?.filter(
        (item) => item.StageType !== Enums.StageType.Completed
      );

    useEffect(() => {
      document.documentElement.style.setProperty(
        "--dropdown-bg-stage-color",
        backgroundColor
      );

      document.documentElement.style.setProperty(
        "--dropdown-stage-color",
        getTextColor(backgroundColor)
      );
    }, [backgroundColor]);

    const handleChange = (args) => {
      const selectedColor = args.itemData?.Color;
      setBackgroundColor(selectedColor);

      args.id = id;
      change?.(args);
    };

    useImperativeHandle(
      ref,
      () => ({
        getValue: () => componentRef.current.getValue(),
        setCurrentBoardId,
        getComponentRef: () => componentRef.current,
      }),
      [componentRef]
    );

    if (isPending)
      return (
        <SkeletonComponent
          height={"1.5em"}
          className="my-1"
          shimmerEffect="Fade"
        />
      );

    return (
      <div className="stage-dd w-50">
        <DropDown
          ref={componentRef}
          change={handleChange}
          name="StageId"
          value={initialValue ?? stages?.[0]}
          dataSource={stages}
          fields={{ text: "Title", value: "Id" }}
          htmlFor={id}
          id={id}
          style={{
            "--dropdown-bg-stage-color": backgroundColor,
            "--dropdown-stage-color": getTextColor(backgroundColor),
          }}
          locale={i18n?.language}
          enabled={!disabled}
          allowObjectBinding
        />
      </div>
    );
  }
);
